import { isPlatformBrowser, Location, NgClass } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ChangeDetectionStrategy, LOCALE_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { WindowRef } from '../../services/window.service';
import { ContactFooterComponent } from '../footer/contact-footer/contact-footer.component';
import { NavigateBackComponent } from './navigate-back/navigate-back.component';

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [RouterOutlet, NavigateBackComponent, RouterModule, NgClass, ContactFooterComponent],
  templateUrl: './navigation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './navigation.component.scss'
})
export class NavigationComponent {
  pageHeading = $localize`AlbCode - Software und Webentwicklung`;
  readonly activeLocale: 'de' | 'en';

  constructor(public location: Location, @Inject(PLATFORM_ID) private platformId: any, private windowRef: WindowRef,
    private router: Router, private activatedRoute: ActivatedRoute, @Inject(LOCALE_ID) localeId: string
  ) {
    this.activeLocale = localeId.startsWith('en') ? 'en' : 'de';
  }

  ngOnInit() {
    this.updatePageHeading();
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.updatePageHeading();
    });
  }

  closeToggleMenu() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    document.getElementById('navbarToggler')?.classList.remove('show');
    const togglerButton = document.getElementById('toggler-button');
    togglerButton?.classList.add('collapsed');
    togglerButton?.setAttribute('aria-expanded', 'false');
  }

  onActivate() {
    if (isPlatformBrowser(this.platformId)) {
      this.windowRef.nativeWindow.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  languageUrl(locale: 'de' | 'en'): string {
    const internalUrl = this.router.url.replace(/^\/(de|en)(?=\/|$)/, '') || '/';
    return locale === 'en' ? `/en${internalUrl === '/' ? '/' : internalUrl}` : internalUrl;
  }

  private updatePageHeading(): void {
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const title = route.snapshot.data['title'] as string | undefined;
    this.pageHeading = this.normalizeHeading(title);
  }

  private normalizeHeading(title?: string): string {
    if (!title) {
      return $localize`AlbCode - Software und Webentwicklung`;
    }

    return title
      .replace(/\s*\|\s*AlbCode.*/i, '')
      .replace(/AlbCode\s*[\-|–]\s*/i, '')
      .trim();
  }

}
